<template>
   <div class="container" :class=" dataAffiliate.active ? '' : 'bg-danger'">
      <div class="row">
         <div class="col-12 text-start">
            <i><b>{{dataAffiliate.name}}</b></i>
         </div>
         <div class="col-12 col-md-4 text-start">
            <i>{{dataAffiliate.documentType}}: <b>{{dataAffiliate.documentNumber}}</b></i>
         </div>
         <div class="col-12 col-md-8 text-start text-md-end">
            <i>Provincia: <b>{{dataAffiliate.provinceState}}</b></i>
         </div>
         <div class="col-12 col-md-9 text-start">
            <i>Fecha de Nacimiento: <b>{{ dateTime( dataAffiliate.birthDate ) }}</b></i>
         </div>
         <div class="col-12 col-md-3 text-start text-md-end">
             <i>Edad: <b>{{dataAffiliate.yearsOld}}</b></i>
         </div>
         <div class="col-12 col-md-8 text-start">
            <i>Email: <b>{{ dataAffiliate.email }}</b></i>
         </div>
         <div class="col-12 col-md-4 text-start text-md-end">
             <i>Parentesco: <b>{{dataAffiliate.relationship}}</b></i>
         </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment';

export default {
   props: {
      dataAffiliate: Object
   },
   
   setup() {
      
      function dateTime(dtValue) {
         return moment(dtValue).format('DD-MM-YYYY');
         //return moment(dtValue).format('YYYY-MM-DD HH:mm:ss');
      }
   
   return { dateTime }
   }
   
}
</script>